import { type ReactNode } from 'react';
import type { CreatorCategory, CreatorType } from '@/types';
import { categoryLabel } from '@/utils/creator-helpers';

export function CategoryBadge({
  type,
  category,
}: {
  type: CreatorType;
  category: CreatorCategory;
}): ReactNode {
  return (
    <span className="inline-flex whitespace-nowrap rounded-sm bg-white/[0.04] px-1.5 py-0.5 text-[11px] text-text-secondary">
      {categoryLabel(type, category)}
    </span>
  );
}
